import { z } from 'zod';

/*
 * El Salvador's locations since the 2024 reorganization: 14 departments, 44
 * municipalities, 262 districts. People still name places by their district (the
 * former municipality: Santa Tecla, Antiguo Cuscatlán), so the district is the main
 * value everywhere (forms, lists, filters, search, import) and the new municipality is
 * shown as secondary information.
 */
export interface DistrictView {
  id: number;
  name: string;
  municipality: { id: number; name: string };
  department: { id: number; name: string; isoCode: string };
}

export interface LocationTree {
  departments: {
    id: number;
    name: string;
    isoCode: string;
    municipalities: { id: number; name: string; districts: { id: number; name: string }[] }[];
  }[];
}

export const districtSearchSchema = z.strictObject({
  q: z.string().trim().min(1, 'Escribe parte del nombre').max(60),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type DistrictSearchInput = z.infer<typeof districtSearchSchema>;

/** "Santa Tecla · La Libertad Sur": district first, municipality as the secondary part. */
export function formatDistrict(district: Pick<DistrictView, 'name' | 'municipality'>): string {
  return `${district.name} · ${district.municipality.name}`;
}
